"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var safeInstanceOf_1 = require("./safeInstanceOf");
/**
 * Check if the given object is HTMLElement
 * @param obj The object to check
 */
function isHTMLElement(obj) {
    return safeInstanceOf_1.default(obj, 'HTMLElement');
}
exports.default = isHTMLElement;
//# sourceMappingURL=isHTMLElement.js.map